import { useState } from "react";
import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { faqs } from "@/mocks/guide";

export default function Faq() {
  const [openId, setOpenId] = useState<string>(faqs[0].id);

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-4xl px-4 md:px-8">
        <Reveal>
          <SectionHeading
            align="center"
            eyebrow="常见问题"
            title="关于这部作品的常见疑问"
            desc="把观众最常提出的问题集中在这里，点击任意一条即可展开答案。"
          />
        </Reveal>

        <div className="mt-10 space-y-3">
          {faqs.map((item, index) => {
            const isOpen = openId === item.id;
            return (
              <Reveal key={item.id} delay={Math.min(index * 60, 200)}>
                <div
                  className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                    isOpen ? "border-primary-300" : "border-background-200"
                  }`}
                >
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpenId(isOpen ? "" : item.id)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">{item.q}</span>
                    <i
                      className={`shrink-0 text-lg text-primary-600 transition-transform ${
                        isOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"
                      }`}
                    />
                  </button>
                  {isOpen ? (
                    <div className="border-t border-background-200 px-5 pb-5 pt-4">
                      <p className="text-sm leading-7 text-foreground-700 md:text-base md:leading-8">{item.a}</p>
                    </div>
                  ) : null}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}